export const styles = {
  CardContainer: {
    backgroundColor: "white",
    margin: "20px",
  },
  TitleStyle: {
    fontWeight: "bold",
    // color: "#fdedbc",
    // textShadow: `
    //   -1px -1px 0 #000,
    //    1px -1px 0 #000,
    //   -1px  1px 0 #000,
    //    1px  1px 0 #000
    // `,
  },

  ButtonStyle: {
    backgroundColor: "#fdedbc",
    fontWeight: "bold",
    color: "#000",
  },
};
